module.exports = __webpack_public_path__ + "img/return.762dda8f.svg";